import React from "react";
import ResumeItem from "./ResumeItem";

function ResumeBox() {
  return (
    <div className="container">
      <div className="tokyo_tm_resumebox">
        <div className="container">
          <div className="in">
            <div className="left">
              <div className="tokyo_section_title">
                <h3>Experience</h3>
              </div>
              <div className="tokyo_tm_resume_list">
                <ul>
                  <ResumeItem
                    year="Sep 2022 - Present"
                    title="PT. Sumber Alfaria Trijaya, Tbk"
                    desc="IT Business Integration Intern"
                  />
                  <ResumeItem
                    year="Feb 2022 - Jul 2022"
                    title="Bangkit Academy"
                    desc="Android Learning Path Student"
                  />
                  <ResumeItem
                    year="Jan 2022 - Apr 2022"
                    title="Satya Wacana Christian University"
                    desc="Assistant Lecture in Algorithm and Data Structure"
                  />
                  <ResumeItem
                    year="Nov 2021 - Nov 2022"
                    title="Hult Prize at Campus"
                    desc="Website Team Comitee"
                  />
                  <ResumeItem
                    year="Nov 2021"
                    title="GEMASTIK 2021"
                    desc="Champion of Programming Competition"
                  />
                  <ResumeItem
                    year="Jan 2021 - Dec 2021"
                    title="Sayflash.id Startup"
                    desc="Front End Engineer"
                  />
                  <ResumeItem
                    year="Nov 2020 - Apr 2021"
                    title="FIT Competition 2019"
                    desc="Event Division"
                  />
                  <ResumeItem
                    year="Aug 2020 - Dec 2020"
                    title="Satya Wacana Christian University"
                    desc="Assistant Lecture in Discrete Mathematics"
                  />
                </ul>
              </div>
            </div>
            <div className="right">
              <div className="tokyo_section_title">
                <h3>Education</h3>
              </div>
              <div className="tokyo_tm_resume_list">
                <ul>
                  <ResumeItem
                    year="Jul 2019 - Present"
                    title="Satya Wacana Christian University"
                    desc="Information Technology - Bachelor Degree"
                  />
                  <ResumeItem
                    year="Jul 2016 - Jul 2019"
                    title="Yos Sudarso High School"
                    desc="Science"
                  />
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResumeBox;
